/** sessionStorage：Magic Link invite token（登录/注册/扫码全程保留） */
export const PROXY_INVITE_TOKEN_KEY = 'proxyInviteToken'

/** 写入 invite token */
export function saveProxyInviteToken (token) {
  const t = String(token || '').trim()
  if (!t) return false
  try {
    sessionStorage.setItem(PROXY_INVITE_TOKEN_KEY, t)
    return true
  } catch {
    return false
  }
}

/** 读取 invite token */
export function readProxyInviteToken () {
  try {
    return String(sessionStorage.getItem(PROXY_INVITE_TOKEN_KEY) || '').trim()
  } catch {
    return ''
  }
}

/** 激活成功或不再需要时清除 */
export function clearProxyInviteToken () {
  try {
    sessionStorage.removeItem(PROXY_INVITE_TOKEN_KEY)
  } catch { /* ignore */ }
}

/**
 * 合并 URL query token 与 sessionStorage（query 优先并回写 storage）
 * @param {string} [queryToken] route.query.token
 */
export function resolveProxyInviteToken (queryToken) {
  const fromQuery = String(queryToken || '').trim()
  if (fromQuery) {
    saveProxyInviteToken(fromQuery)
    return fromQuery
  }
  return readProxyInviteToken()
}
